export const INVITED_TEAM_ID_QUERY_PARAM = 'invitedTeamId' as const;
